module.exports = __webpack_public_path__ + "img/foto-oscar-martins.jpeg";